import React from 'react'
import ReactDOM from 'react-dom'
import { matchPath } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { createBrowserHistory } from 'history'
import { routeConfig } from 'src/routes/config'
import App from './App'

import './assets/styles/app.scss'

const history = createBrowserHistory()

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.reactRouterV5Instrumentation(
                history,
                routeConfig,
                matchPath
            ),
        }),
    ],
    tracesSampleRate:
        process.env.REACT_APP_SENTRY_ENV === 'development' ? 1 : 0.2,
    environment: process.env.REACT_APP_SENTRY_ENV,
})

ReactDOM.render(<App history={history} />, document.getElementById('root'))
